import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { AgeGate } from '../compliance/AgeGate';
import { CookieBanner } from '../compliance/CookieBanner';
import { WarningBanner } from '../compliance/WarningBanner';

type Props = {
  children?: React.ReactNode;
};

export function SiteLayout({ children }: Props) {
  const location = useLocation();
  const [routeAnim, setRouteAnim] = React.useState(false);

  React.useEffect(() => {
    setRouteAnim(false);
    const raf = window.requestAnimationFrame(() => setRouteAnim(true));
    return () => window.cancelAnimationFrame(raf);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-zinc-950 bg-radial-fade bg-no-repeat">
      <a
        href="#contenu"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[80] focus:rounded-xl focus:bg-zinc-900 focus:px-4 focus:py-2 focus:text-white focus:ring-2 focus:ring-fuchsia-400/70"
      >
        Aller au contenu
      </a>
      <div className="sticky top-0 z-50">
        <WarningBanner />
        <Header />
      </div>
      <main id="contenu" className="min-h-[70vh]">
        <div
          className={[
            'transition-all duration-300 ease-out',
            routeAnim ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1',
          ].join(' ')}
        >
          {children ?? <Outlet />}
        </div>
      </main>
      <Footer />
      <CookieBanner />
      <AgeGate />
    </div>
  );
}


